module.exports = __webpack_public_path__ + "img/493ee3f.jpg";